export default "__VITE_ASSET__hhYhK$xe__"